/**
 * Create a unique hash from a string.
 *
 * Note: This is not a secure implementation and
 * should not be used for hashing passwords, etc.
 */
export var hashString = function (input) {
    var hash = 0;
    if (input.length === 0) {
        return hash.toString();
    }
    for (var i = 0; i < input.length; i++) {
        var char = input.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash.toString();
};
